import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH_ALL() {
      return this.get(links.MEETING_GUESTS(), {
        dataKey: "hydra:member",
      });
    },
    FETCH(meetingId) {
      return this.get(links.MEETING_MEETING_GUESTS(meetingId), {
        dataKey: "hydra:member",
      });
    },
    PUT(item) {
      return this.put(links.MEETING_GUEST_PUT(item.id), item);
    },
    POST(item) {
      return this.post(links.MEETING_GUEST_POST(), item);
    },
    GET(id) {
      return this.get(links.MEETING_GUEST_GET(id));
    },
    DELETE(item) {
      return this.delete(links.MEETING_GUEST_DELETE(item.id), {
        delete: item.id,
      });
    },
    REGISTER(item) {
      return this.post(links.REGISTER_MEETING_GUEST(), item);
    },
    GET_BY_BUILDING(buildingId) {
      return this.get(links.MEETING_GUEST_GET_BY_BUILDING(buildingId), {
        dataKey: "hydra:member",
      });
    },
  },
};
